module.exports = __webpack_public_path__ + "static/media/bindQQ2.2c8691fb.png";